import {useCallback} from "react";
import {triggerBlobDownload} from "@/lib/blob-download";

/**
 * Hook that provides a CSV download trigger function.
 *
 * Calls the given API function, reads the CSV string from the response,
 * creates a Blob and triggers a browser file download via a temporary anchor element.
 *
 * @param filename - The name of the downloaded file (e.g. "requests-by-company.csv")
 * @returns A function that accepts an API call returning the CSV response and triggers the download
 */
const useCsvExport = (filename: string) =>
    useCallback(
        async (apiFn: () => Promise<{ data: string }>) => {
            const response = await apiFn();
            const blob = new Blob([response.data], {type: "text/csv;charset=utf-8;"});
            triggerBlobDownload(blob, filename);
        },
        [filename]
    );

export default useCsvExport;
